import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Contractor, useMusicApi } from "../api/useMusicApi";

interface IContextProps {
  contractors: Contractor[];
}

// @ts-ignore
const ContractorsContext = createContext<IContextProps>();

export const ContractorsContextProvider: React.FC<any> = ({ children }) => {
  const { getContractors } = useMusicApi();
  const [contractors, setContractors] = useState<Contractor[]>([]);

  useEffect(() => {
    void fetchContractors();
  }, []);

  const fetchContractors = useCallback(async () => {
    try {
      const res = await getContractors();
      setContractors(res.results);
    } catch (e) {}
  }, []);
  return (
    <ContractorsContext.Provider value={{ contractors }}>
      {children}
    </ContractorsContext.Provider>
  );
};

export function useContractors() {
  return useContext(ContractorsContext);
}
